import { CommonService } from "../services/common.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Component, HostListener } from "@angular/core";

@Component({
  selector: "app-chatbot",
  templateUrl: "./chatbot.component.html",
  styleUrls: ["./chatbot.component.css"],
})
export class ChatbotComponent {
  showChatbot = false;
  chatbotUrl: SafeResourceUrl | any;
  useremail: any = sessionStorage.getItem("USERNAME");
  name: string | any = sessionStorage.getItem("FullName");
  mobilenumber: string | any = localStorage.getItem("mobilenumber");
  isLoggedIn = false;
  iframeScale = 1;
  pendingClearSession: boolean = false;
  chatbotDynamicUrl: string =
    location.href.includes("https://bedev.samvaadpro.com") ||
    location.href.includes("http://localhost")
      ? "https://helpdesk-pro.dhanushinfotech.com/chatbot"
      : location.href.includes("https://kemis.go.ke")
        ? "https://helpdesk.kemis.go.ke/chatbot/enc"
        : "https://kemis-helpdesk-pro.dhanushinfotech.com/chatbot/enc";
  // chatbotUrlPreprod: string = "https://kemis-helpdesk-pro.dhanushinfotech.com/chatbot";
  // chatbotUrlProd: string = "https://helpdesk.kemis.go.ke/chatbot";
  // bedevUrl: string = "https://bedev.samvaadpro.com";

  // private loggedInUrl = `${this.chatbotUrldev}/signup/${this.useremail}/pass123/${this.name}/${254}${this.mobilenumber}`;

  private guestUrl = this.chatbotDynamicUrl;

  constructor(private sanitizer: DomSanitizer) {
    // this.setChatbotUrl();
  }

  setChatbotUrl() {
    this.isLoggedIn = sessionStorage.getItem("isLogIn") === "true";

    const useremail = sessionStorage.getItem("USERNAME");
    const name = sessionStorage.getItem("FullName");
    const mobilenumber = localStorage.getItem("mobilenumber");

    if (this.isLoggedIn && useremail && name) {
      const url = `${this.chatbotDynamicUrl}/signup/${encodeURIComponent(useremail)}/pass123/${encodeURIComponent(name)}/254${mobilenumber || ""}`;
      this.chatbotUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    } else {
      this.chatbotUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        `${this.guestUrl}?clearSession=true`,
      );
    }

    this.setIframeScale();
  }

  @HostListener("window:resize")
  onWindowResize() {
    this.setIframeScale();
  }

  setIframeScale() {
    const width = window.innerWidth;

    if (!this.isLoggedIn) {
      this.iframeScale = 1;
      return;
    }

    // Match React approach: use conservative scale based on viewport
    if (width < 480) {
      this.iframeScale = 0.68;
    } else if (width < 768) {
      this.iframeScale = 0.72;
    } else if (width < 1024) {
      this.iframeScale = 0.76;
    } else if (width < 1280) {
      this.iframeScale = 0.8;
    } else {
      this.iframeScale = 0.82;
    }
  }

  toggleChatbot() {
    if (!this.isLoggedIn) {
      this.pendingClearSession = true;
    } else {
      this.pendingClearSession = false;
    }
    if (!this.showChatbot) {
      this.setChatbotUrl(); // fetch latest session values
    }
    this.showChatbot = !this.showChatbot;
  }

  onIframeLoad() {
    if (!this.pendingClearSession) {
      return;
    }
    setTimeout(() => {
      const chatbotOrigin = this.chatbotDynamicUrl.replace("/chatbot", "");
      const iframe = document.getElementById(
        "chatbotFrame",
      ) as HTMLIFrameElement;

      iframe?.contentWindow?.postMessage(
        {
          action: "clearSession",
        },
        chatbotOrigin,
      );
      const params = new URLSearchParams(window.location.search);

      if (params.get("clearSession") === "true") {
        sessionStorage.removeItem("chatbot_user_context");
      }

      this.pendingClearSession = false;
    }, 1000);
  }
}
